import { buildObjectSifter, FilterRulesSchema } from '@reachmedianetwork/object-filter';
import FilterRules from './FilterRules.json';

export const BuiltInLogEventFilterRules = FilterRulesSchema.parse(FilterRules);

export const builtInLogSifter = buildObjectSifter(BuiltInLogEventFilterRules);
